if (!Shopify.designMode) {
  const heightWatchers = {};
  // Maps overlay <header> elements → { group, key } so the ResizeObserver
  // callback can update the correct CSS variable even though the element
  // doesn't carry a group-*-group class name.
  const overlayElementGroupMap = new Map();

  const setGroupHeight = (group) => {
    if (!heightWatchers[group]) return;
    const sum = Object.values(heightWatchers[group]).reduce((a, b) => a + b, 0);
    document.documentElement.style.setProperty(`--${group}-height`, `${sum}px`);
  };

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      var regex = /group-(.+?)-group/;
      const matches = entry.target.className.match(regex);
      if (matches) {
        // Normal section-group wrapper
        const group = matches[1];
        if (!heightWatchers[group]) {
          heightWatchers[group] = {};
        }
        heightWatchers[group][entry.target.id] = entry.contentRect.height;
        setGroupHeight(group);
      } else if (overlayElementGroupMap.has(entry.target)) {
        // Overlay <header> — use getBoundingClientRect for the full box height
        // (the element is absolutely positioned so contentRect may omit padding)
        const { group, key } = overlayElementGroupMap.get(entry.target);
        if (!heightWatchers[group]) {
          heightWatchers[group] = {};
        }
        heightWatchers[group][key] =
          entry.target.getBoundingClientRect().height;
        setGroupHeight(group);
      }
    });
  });

  const heightElements = document.querySelectorAll(
    ".shopify-section-group-header-group",
  );
  heightElements.forEach((element) => {
    // When a section contains an overlay header the wrapper collapses to 0
    // height (absolute positioning removes the child from normal flow).
    // Observe the <header> element directly so we capture its real height.
    const overlayHeader = element.querySelector(
      '[data-enable-overlay-header="true"]',
    );
    if (overlayHeader) {
      var regex = /group-(.+?)-group/;
      const matches = element.className.match(regex);
      if (matches) {
        overlayElementGroupMap.set(overlayHeader, {
          group: matches[1],
          key: element.id,
        });
        resizeObserver.observe(overlayHeader);
        return; // skip observing the zero-height wrapper
      }
    }
    resizeObserver.observe(element);
  });
} else {
  /**
   * ResizeObserver doesn’t work inside Theme Editor
   */
  const calculateHeaderGroupHeights = () => {
    const headerGroupHeights = [];

    document
      .querySelectorAll(".shopify-section-group-header-group")
      .forEach((headerGroupSectionEl) => {
        // When the header is in overlay mode its wrapper collapses to 0 height
        // (absolute positioning). Measure the <header> element directly instead.
        const overlayHeader = headerGroupSectionEl.querySelector(
          '[data-enable-overlay-header="true"]',
        );
        headerGroupHeights.push(
          overlayHeader
            ? overlayHeader.getBoundingClientRect().height
            : headerGroupSectionEl.getBoundingClientRect().height,
        );
      });

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerGroupHeights.reduce((subtotal, a) => subtotal + a, 0)}px`,
    );
  };

  calculateHeaderGroupHeights();

  const debouncedCalculateHeaderGroupHeights = debounce(
    calculateHeaderGroupHeights,
    150,
  );

  window.addEventListener("resize", debouncedCalculateHeaderGroupHeights);

  document.body.addEventListener("shopify:section:select", (e) => {
    if (!e.target.matches(".shopify-section-group-header-group")) return;

    window.dispatchEvent(new Event("resize"));
  });

  document.body.addEventListener("shopify:section:load", (e) => {
    if (!e.target.matches(".shopify-section-group-header-group")) return;

    window.dispatchEvent(new Event("resize"));
  });

  document.body.addEventListener("shopify:section:unload", (e) => {
    if (!e.target.matches(".shopify-section-group-header-group")) return;

    window.dispatchEvent(new Event("resize"));
  });
}
